<template>
	<div>
		<v-card>
			<v-tabs v-model="tab" icons-and-text>
				<v-tab @click="listAuditorium();">
					Track List
					<v-icon>mdi-vector-polyline-edit</v-icon>
				</v-tab>
			</v-tabs>

			<!-- Add/Edit/Delete Button -->
			<v-tabs-items v-model="tab">
				<v-tab-item>
					<v-card flat>
						<v-col class="text-right">
							<v-btn class="ma-2" @click.prevent="clear(); dialogAddAuditorium = true;">
								Add Auditorium
								<v-icon dark>mdi-plus-thick</v-icon>
							</v-btn>
						</v-col>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Auditorium Name (Auditorium Id) Time Zone</th>
										<th class="text-center">Action Edit</th>
										<th class="text-center">Action Delete</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idxItem) in auditoriumList" :key="idxItem">
										<td>
											{{ item.name }} ({{ item.id }}) {{item.timeZoneText}}
											<br />
											<v-btn
												class="ma-2"
												small
												text
												@click.prevent="clear(); dialogAddTrack = true; trackList = item.trackList; selectedAuditoriumId = item.id;"
											>
												<v-icon dark>mdi-plus-thick</v-icon>Add Track
											</v-btn>

											<v-simple-table v-if="item.trackList.length > 0">
												<template v-slot:default>
													<thead>
														<tr>
															<th class="text-left">Track Id</th>
															<th class="text-left">Sort Order</th>
															<th class="text-left">Track Name</th>
															<th class="text-center">Action</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(itemTrack, idxItemTrack) in item.trackList" :key="idxItemTrack">
															<td>{{ itemTrack.id }}</td>
															<td>{{ itemTrack.sortOrder }}</td>
															<td>
																<div :style="'padding-left: '+(itemTrack.level*20)+'px;'">{{ itemTrack.name }}</div>
															</td>
															<td class="text-center">
																<v-btn
																	class="ma-2"
																	text
																	small
																	@click.prevent="showEditTrack(item, itemTrack)"
																>
																	<v-icon dark>mdi-pencil</v-icon>
																</v-btn>
																<v-btn class="ma-2" text small @click.prevent="selectedTrackId = itemTrack.id; dialogDeleteTrack = true;">
																	<v-icon dark>mdi-delete</v-icon>
																</v-btn>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
											<br />
										</td>
										<td class="text-center">
											<v-btn
												class="ma-2"
												@click.prevent="showEditAuditorium(item)"
											>
												Edit
												<v-icon dark>mdi-pencil</v-icon>
											</v-btn>
										</td>
										<td class="text-center">
											<v-btn class="ma-2" @click.prevent="selectedAuditoriumId = item.id; dialogDeleteAuditorium = true;">
												Delete
												<v-icon dark>mdi-delete</v-icon>
											</v-btn>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>

		<!-- Dialog Add Auditorium -->
		<v-dialog v-model="dialogAddAuditorium" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Add Auditorium</span>
				</v-card-title>
				<v-card-text>
					<v-form ref="form" v-model="valid">
						<v-row>
							<v-col>
								<v-text-field v-model="entityAuditorium.name" label="Auditorium Name" required></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="entityAuditorium.timeZoneText"
									label="Time Zone"
									hint="Text that appears after schedule e.g. AEST in 10:00AM - 11:00AM AEST"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="entityAuditorium.allowTicketList"
									:items="ticketList"
									item-text="name"
									item-value="id"
									label="Allowed Ticket List"
									multiple
									chips
									hint="Empty list means all access"
									persistent-hint
								></v-select>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="entityAuditorium.denyTicketList"
									:items="ticketList"
									item-text="name"
									item-value="id"
									label="Denied Ticket List"
									multiple
									chips
								></v-select>
							</v-col>
						</v-row>
						<v-spacer></v-spacer>
						<div class="d-flex justify-end">
							<v-btn
								:disabled="!valid"
								type="submit"
								@click.prevent="saveAuditorium(); dialogAddAuditorium = false; listAuditorium();"
								color="primary darken-1"
								depressed
								tile
							>Save</v-btn>
						</div>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Dialog Edit Auditorium -->
		<v-dialog v-model="dialogEditAuditorium" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Edit Auditorium</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field v-model="entityAuditorium.name" label="Auditorium Name" required></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field v-model="entityAuditorium.timeZoneText" label="Time Zone" hint="Text that appears after schedule e.g. AEST in 10:00AM - 11:00AM AEST"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="entityAuditorium.allowTicketList"
									:items="ticketList"
									item-text="name"
									item-value="id"
									label="Allowed Ticket List"
									multiple
									chips
									hint="Empty list means all access"
									persistent-hint
								></v-select>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="entityAuditorium.denyTicketList"
									:items="ticketList"
									item-text="name"
									item-value="id"
									label="Denied Ticket List"
									multiple
									chips
								></v-select>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click.prevent="dialogEditAuditorium = false;">Cancel</v-btn>
					<v-btn color="blue darken-1" text @click.prevent="dialogEditAuditorium = false; editAuditorium();">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog Delete Auditorium -->
		<v-dialog v-model="dialogDeleteAuditorium" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete Auditorium</span>
				</v-card-title>
				<v-card-text>Are you sure to delete this auditorium?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click.prevent="dialogDeleteAuditorium = false;">Cancel</v-btn>
					<v-btn color="blue darken-1" text @click.prevent="dialogDeleteAuditorium = false; deleteAuditorium();">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog Add Track -->
		<v-dialog v-model="dialogAddTrack" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Add Track</span>
				</v-card-title>
				<v-card-text>
					<v-form ref="form" v-model="valid">
						<v-row>
							<v-col>
								<v-text-field v-model="entityTrack.name" label="Track Name" required></v-text-field>
								<v-text-field v-model="entityTrack.sortOrder" label="Sort Order"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="entityTrack.allowTicketList"
									:items="ticketList"
									item-text="name"
									item-value="id"
									label="Allowed Ticket List"
									multiple
									chips
									hint="Empty list means all access"
									persistent-hint
								></v-select>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="entityTrack.denyTicketList"
									:items="ticketList"
									item-text="name"
									item-value="id"
									label="Denied Ticket List"
									multiple
									chips
								></v-select>
							</v-col>
						</v-row>
						<v-spacer></v-spacer>
						<div class="d-flex justify-end">
							<v-btn
								:disabled="!valid"
								type="submit"
								@click.prevent="saveTrack(); dialogAddTrack = false; listAuditorium();"
								color="primary darken-1"
								depressed
								tile
							>Save</v-btn>
						</div>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Dialog Edit Track -->
		<v-dialog v-model="dialogEditTrack" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Edit Track</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field v-model="entityTrack.name" label="Track Name" required></v-text-field>
								<v-text-field v-model="entityTrack.sortOrder" label="Sort Order"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="entityTrack.allowTicketList"
									:items="ticketList"
									item-text="name"
									item-value="id"
									label="Allowed Ticket List"
									multiple
									chips
									hint="Empty list means all access"
									persistent-hint
								></v-select>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="entityTrack.denyTicketList"
									:items="ticketList"
									item-text="name"
									item-value="id"
									label="Denied Ticket List"
									multiple
									chips
								></v-select>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click.prevent="dialogEditTrack = false;">Cancel</v-btn>
					<v-btn color="blue darken-1" text @click.prevent="dialogEditTrack = false; editTrack();">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog Delete Track -->
		<v-dialog v-model="dialogDeleteTrack" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete Track</span>
				</v-card-title>
				<v-card-text>Are you sure to delete this track ?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click.prevent="dialogDeleteTrack = false;">Cancel</v-btn>
					<v-btn color="blue darken-1" text @click.prevent="dialogDeleteTrack = false; deleteTrack();">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: ["experienceId"],
	data() {
		return {
			valid: true,
			tab: null,
			entityTrack: {
				name: null,
				parentTrackId: null,
				auditoriumId: null,
				sortOrder: null,
				dataMap: {}
			},
			entityAuditorium: {
				name: null,
				dataMap: {}
			},
			experiences: null,
			trackList: null,
			auditoriumList: null,
			firstTracks: null,
			presentations: [],
			selectedName: null,
			selectedTimeZoneText: null,
			selectedParentTrackId: null,
			selectedTrackId: null,
			selectedAuditoriumId: null,
			selectedSortOrder: null,
			dialogAddTrack: false,
			dialogEditTrack: false,
			dialogDeleteTrack: false,
			dialogAddAuditorium: false,
			dialogEditAuditorium: false,
			dialogDeleteAuditorium: false,
			ticketList: [],
			baseLocation: axios.defaults.baseURL
		};
	},
	mounted() {
		this.listAuditorium();
		this.listTicket();
	},
	methods: {
		listAuditorium() {
			axios
				.post("/system/auditorium/list", {
					experienceId: this.experienceId
				})
				.then(response => {
					this.auditoriumList = response.data;
				})
				.catch(() => {});
		},
		saveTrack() {
			this.entityTrack.parentTrackId = this.selectedParentTrackId;
			this.entityTrack.auditoriumId = this.selectedAuditoriumId;
			this.entityTrack.dataMap = {};

			axios
				.post("/system/track/add", {
					experienceId: this.experienceId,
					entity: this.entityTrack
				})
				.then(() => {
					this.listAuditorium();
				})
				.catch(() => {});
		},
		editTrack() {
			this.entityTrack.dataMap = {};

			axios
				.post("/system/track/edit", {
					entity: this.entityTrack
				})
				.then(() => {
					this.listAuditorium();
				})
				.catch(() => {});
		},
		deleteTrack() {
			axios
				.post("/system/track/delete", {
					id: this.selectedTrackId
				})
				.then(() => {
					this.listAuditorium();
				})
				.catch(() => {});
		},
		saveAuditorium() {
			this.entityAuditorium.dataMap = {};

			axios
				.post("/system/auditorium/add", {
					experienceId: this.experienceId,
					entity: this.entityAuditorium
				})
				.then(() => {
					this.listAuditorium();
				})
				.catch(() => {});
		},
		editAuditorium() {
			this.entityAuditorium.dataMap = {};
			axios
				.post("/system/auditorium/edit", {
					entity: this.entityAuditorium
				})
				.then(() => {
					this.listAuditorium();
				})
				.catch(() => {});
		},
		deleteAuditorium() {
			axios
				.post("/system/auditorium/delete", {
					id: this.selectedAuditoriumId
				})
				.then(() => {
					this.listAuditorium();
				})
				.catch(() => {});
		},
		clear() {
			this.entityTrack = {
				name: null,
				parentTrackId: null,
				auditoriumId: null,
				sortOrder: null,
				dataMap: {}
			};
			this.entityAuditorium = {
				name: null,
				dataMap: {}
			};
			this.selectedParentTrackId = null;
			this.selectedAuditoriumId = null;
			this.selectedName = null;
		},
		listTicket() {
			axios
				.get("/system/ticket/list?experienceId=" + this.experienceId)
				.then(response => {
					this.ticketList = response.data;
				})
				.catch(() => {});
		},
		showEditAuditorium(item) {
			this.entityAuditorium = Object.assign({}, item);
			axios
				.get("/system/auditorium?id=" + item.id)
				.then(response => {
					this.entityAuditorium.allowTicketList = response.data.allowTicketList;
					this.entityAuditorium.denyTicketList = response.data.denyTicketList;
					this.dialogEditAuditorium = true;
				})
				.catch(() => {});
		},
		showEditTrack(item, itemTrack) {
			this.trackList = item.trackList;
			this.entityTrack = Object.assign({}, itemTrack);
			axios
				.get("/system/track?id=" + itemTrack.id)
				.then(response => {
					this.entityTrack.allowTicketList = response.data.allowTicketList;
					this.entityTrack.denyTicketList = response.data.denyTicketList;
					this.dialogEditTrack = true;
				})
				.catch(() => {});
		}
	}
};
</script>
